import { createApp } from 'vue';
import { RouteRecordRaw } from 'vue-router';
import 'nprogress/nprogress.css';
import '@/assets/style/main.scss';
import 'element-plus/dist/index.css';
import { setLocale } from '@/composition/useLangSet';
import { checkUser } from '@/router/middleware/auth';
import { checkUserAuthWithSSO, firstLoadSpinnerRemove } from '@/utils/iframeKeycloakAuth';
import websocketConnect from '@/services/websocket';
import { getFallbackLocale, loginUser } from '@/services/userActions';
import { i18n, defaultLocale } from '@/i18n';
import { PortalLocaleEnum } from '@/types/enums';
import App from './App.vue';
import router, { getRoutes } from './router';
import store from './store';
import { mountApp } from './mountApp';

const setDefaultLocale = async () => {
  let locales;
  try {
    locales = await getFallbackLocale(defaultLocale);
  } catch (err) {
    const shortLang = navigator.language.split('-')[0];
    locales = {
      locale: shortLang,
      fallback_locale: shortLang,
      grand_fallback_locale: shortLang,
      currency: shortLang === PortalLocaleEnum.Russian ? 'RUB' : 'USD',
    };
  }
  store.commit('Locales/SET_CURRENCY', locales.currency);
  i18n.global.fallbackLocale.value = [
    locales.locale || PortalLocaleEnum.English,
    locales.fallback_locale || PortalLocaleEnum.English,
    locales.grand_fallback_locale || PortalLocaleEnum.English,
  ];
};

const launchFunc = async () => {
  setDefaultLocale();

  const role = await checkUser();

  let ssoHasNotError: any = false;
  if (role) {
    firstLoadSpinnerRemove();
  } else {
    ssoHasNotError = await checkUserAuthWithSSO();
  }

  if (ssoHasNotError) {
    loginUser();
  }

  const routes: Array<RouteRecordRaw> = await getRoutes(role);
  routes.forEach((route: RouteRecordRaw) => router.addRoute(route));
  if (role?.length > 0) {
    await websocketConnect();
  }

  // Set app language
  setLocale();

  const app = createApp(App)
    .use(i18n)
    .use(store)
    .use(router);

  mountApp(app);
};

await launchFunc();
